import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "reactstrap";
import DashboardService from "../../../../services/OrderingServices/DashboardService";
import PeriodFilter from "./PeriodFilter";
// import CountUp from "react-countup";

const timeRanges = [
  { label: "All", value: 5, color: "primary" },
  { label: "1 Day", value: 1, color: "info" },
  { label: "7 Days", value: 2, color: "info" },
  { label: "1 Month", value: 3, color: "warning" },
  { label: "1 Year", value: 4, color: "danger" },
];

const itemsPerPage = 5;

const BestSellingProducts = () => {
  const [data, setData] = useState([]);
  const [timeRange, setTimeRange] = useState(1); // default 1 Day
  const [currentPage, setCurrentPage] = useState(1);
  const topN = 50;

  const fetchData = async () => {
    try {
      const response = await DashboardService.getTopItem(timeRange, topN);
      setData(response || []);
      setCurrentPage(1); // reset to first page on filter change
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [timeRange]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const handlePeriodClick = (value) => {
    setTimeRange(value);
  };

  return (
    <Card className="h-100">
      <CardHeader className="border-0 align-items-center d-flex pb-2">
        <h4 className="card-title mb-0 flex-grow-1">Best Selling Products</h4>
        <Row className="flex-shrink-0">
          <Col lg={12} className="text-md-end">
            <ButtonGroup className="bg-light p-1 rounded-pill">
              {timeRanges.map((range) => {
                const isActive = timeRange === range.value;

                return (
                  <Button
                    key={range.value}
                    size="sm"
                    onClick={() => handlePeriodClick(range.value)}
                    className="rounded-pill px-3 fw-medium border-0"
                    style={{
                      backgroundColor: isActive ? "#f79400" : "transparent",
                      borderColor: "#f79400",
                      color: isActive ? "#000" : "#6c757d",
                      opacity: isActive ? 1 : 0.85,
                      textTransform: "capitalize",
                      transition: "all 0.2s ease",
                      fontWeight: isActive ? 600 : 500,
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = "#f79400";
                        e.currentTarget.style.color = "#fff";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "#6c757d";
                      }
                    }}
                  >
                    {range.label}
                  </Button>
                );
              })}
            </ButtonGroup>
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="pt-0">
        <div
          className="table-responsive"
          style={{ minHeight: "300px", overflowY: "auto" }}
        >
          <table
            className="table table-hover table-centered align-middle table-nowrap mb-0"
            style={{ tableLayout: "fixed" }}
          >
            <thead>
              <tr>
                <th style={{ width: "50%" }}>Product</th>
                <th>Qty Sold</th>
                <th>Percentage (%)</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center py-5">
                    <i className="ri-emotion-unhappy-line display-4 text-secondary" />
                    <div className="mt-2 text-muted">No data found</div>
                  </td>
                </tr>
              ) : (
                paginatedData.map((item, key) => (
                  <tr key={key} className="align-middle py-4">
                    <td>
                      <h5
                        className="fs-16 my-1 text-truncate"
                        style={{ maxWidth: "200px" }}
                        title={item.productName}
                      >
                        <Link to="#" className="text-reset">
                          {item.productName}
                        </Link>
                      </h5>
                    </td>
                    <td className="d-flex align-items-center py-4">
                      {item.quantity}
                      <span className="text-muted ms-2">Orders</span>
                    </td>
                    <td className="py-3">
                      <div className="d-flex align-items-center">
                        {item.percentage}
                        <span className="text-muted ms-2">Of Total</span>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {data.length > itemsPerPage && (
          <div className="d-flex align-items-center justify-content-between mt-3">
            <div className="text-muted">
              Showing{" "}
              <span className="fw-semibold">
                {startIndex + 1}-{" "}
                {Math.min(startIndex + itemsPerPage, data.length)}
              </span>{" "}
              of <span className="fw-semibold">{data.length}</span> Results
            </div>
            <ul className="pagination pagination-separated pagination-sm mb-0">
              <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                <Link
                  to="#"
                  className="page-link"
                  onClick={() =>
                    currentPage > 1 && setCurrentPage(currentPage - 1)
                  }
                >
                  ←
                </Link>
              </li>
              {Array.from({ length: totalPages }, (_, idx) => (
                <li
                  key={idx}
                  className={`page-item ${currentPage === idx + 1 && "active"}`}
                >
                  <Link
                    to="#"
                    className="page-link"
                    onClick={() => setCurrentPage(idx + 1)}
                  >
                    {idx + 1}
                  </Link>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages && "disabled"
                }`}
              >
                <Link
                  to="#"
                  className="page-link"
                  onClick={() =>
                    currentPage < totalPages && setCurrentPage(currentPage + 1)
                  }
                >
                  →
                </Link>
              </li>
            </ul>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default BestSellingProducts;
